{
  "golf": {
    "slides": [
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/jw-mrkfl-golf-putt-close-22563?wid=1400&fit=constrain",
        "title": "Championship Golf in Scotland",
        "description": "Play the legendary links courses where golf began, with ocean views and centuries of tradition.",
        "buttonLink": "https://www.marriott.com/en-us/resorts/golf-resorts",
        "activities": [
          {
            "label": "Golf",
            "icon": "golf"
          },
          {
            "label": "Links Course",
            "icon": "course"
          },
          {
            "label": "Scotland",
            "icon": "location"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/content/dam/marriott-renditions/dm-static-renditions/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1257262565-34805-classic-hor.jpg",
        "title": "Desert Golf Retreats",
        "description": "Experience world-class desert courses with stunning mountain backdrops and perfect year-round weather.",
        "buttonLink": "https://moments.marriottbonvoy.com/en-us/moments/category/sports",
        "activities": [
          {
            "label": "Golf",
            "icon": "golf"
          },
          {
            "label": "Desert Course",
            "icon": "desert"
          },
          {
            "label": "Mountain Views",
            "icon": "mountain"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/rz-hnlkz-golf-738776123-21226?wid=1400&fit=constrain",
        "title": "Tropical Golf Escapes",
        "description": "Tee off in paradise with oceanfront courses and luxury resort amenities.",
        "buttonLink": "https://activities.marriott.com/search?term=golf",
        "activities": [
          {
            "label": "Golf",
            "icon": "golf"
          },
          {
            "label": "Oceanfront",
            "icon": "ocean"
          },
          {
            "label": "Tropical",
            "icon": "palm"
          }
        ]
      }
    ]
  },
  "beach": {
    "slides": [
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-whale-bar-aerial-37919-47743?wid=1400&fit=constrain",
        "title": "Two More Nights Unlock Silver Elite Status",
        "description": "Escape to pristine beaches with crystal-clear waters and endless sunshine.",
        "buttonLink": "https://traveler.marriott.com/mindful-travel/reconnect-travel-us-caribbean/",
        "activities": [
          {
            "label": "Beach",
            "icon": "sun"
          },
          {
            "label": "Swimming",
            "icon": "water"
          },
          {
            "label": "Tropical",
            "icon": "palm"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/mv-hnlpw-waikiki-beach-13761?wid=1400&fit=constrain",
        "title": "Two More Nights Unlock Silver Elite Status",
        "description": "Discover secluded coves, water sports, and beachfront luxury resorts.",
        "buttonLink": "https://activities.marriott.com/activities?term=beach",
        "activities": [
          {
            "label": "Beach",
            "icon": "sun"
          },
          {
            "label": "Water Sports",
            "icon": "water"
          },
          {
            "label": "Adventure",
            "icon": "adventure"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/jw-mrkfl-mrkfl-paddleboard41755-72882?wid=1400&fit=constrain",
        "title": "Two More Nights Unlock Silver Elite Status",
        "description": "Watch spectacular sunsets from world-class beachfront destinations.",
        "buttonLink": "https://traveler.marriott.com/outdoor-activities/beach-travel/",
        "activities": [
          {
            "label": "Beach",
            "icon": "sun"
          },
          {
            "label": "Sunset Views",
            "icon": "sunset"
          },
          {
            "label": "Relaxation",
            "icon": "relax"
          }
        ]
      }
    ]
  },
  "ski": {
    "slides": [
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/tx-szgjf-skiing-40984?wid=1400&fit=constrain",
        "title": "Alpine Skiing Adventures",
        "description": "Carve through pristine powder on world-renowned mountain slopes.",
        "buttonLink": "https://www.marriott.com/en-us/outdoors/skiing-and-snowboarding",
        "activities": [
          {
            "label": "Skiing",
            "icon": "ski"
          },
          {
            "label": "Alpine",
            "icon": "mountain"
          },
          {
            "label": "Powder Snow",
            "icon": "snow"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-637078978?wid=1400&fit=constrain",
        "title": "Luxury Ski Resorts",
        "description": "Experience premium ski-in, ski-out accommodations with spa amenities.",
        "buttonLink": "https://traveler.marriott.com/hotel-experiences/best-cold-weather-resorts/",
        "activities": [
          {
            "label": "Skiing",
            "icon": "ski"
          },
          {
            "label": "Luxury Resort",
            "icon": "luxury"
          },
          {
            "label": "Spa",
            "icon": "spa"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-485977037?wid=1400&fit=constrain",
        "title": "Family Ski Destinations",
        "description": "Create memories on gentle slopes perfect for all skill levels.",
        "buttonLink": "https://traveler.marriott.com/outdoor-activities/skiing-and-snowboarding/",
        "activities": [
          {
            "label": "Skiing",
            "icon": "ski"
          },
          {
            "label": "Family Friendly",
            "icon": "family"
          },
          {
            "label": "All Levels",
            "icon": "beginner"
          }
        ]
      }
    ]
  },
  "culinary": {
    "slides": [
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/eb-madeb-market-at-edition-41996?wid=1400&fit=constrain",
        "title": "Michelin Star Experiences",
        "description": "Savor world-class cuisine at renowned restaurants and exclusive chef experiences.",
        "buttonLink": "https://moments.marriottbonvoy.com/en-us/moments/category/culinary",
        "activities": [
          {
            "label": "Fine Dining",
            "icon": "dining"
          },
          {
            "label": "Michelin Star",
            "icon": "star"
          },
          {
            "label": "Chef Experience",
            "icon": "chef"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/content/dam/marriott-renditions/dm-static-renditions/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1424166516-20001-classic-hor.jpg",
        "title": "Local Food Adventures",
        "description": "Discover authentic regional flavors and traditional cooking experiences.",
        "buttonLink": "https://traveler.marriott.com/eat-and-drink/culinary-experiences/",
        "activities": [
          {
            "label": "Local Cuisine",
            "icon": "local"
          },
          {
            "label": "Food Tours",
            "icon": "tour"
          },
          {
            "label": "Traditional",
            "icon": "tradition"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/xr-kulxr-cocktail-motion-10844?wid=1400&fit=constrain",
        "title": "Wine Country Escapes",
        "description": "Tour prestigious vineyards and taste exceptional wines in stunning settings.",
        "buttonLink": "https://traveler.marriott.com/eat-and-drink/bars/",
        "activities": [
          {
            "label": "Wine Tasting",
            "icon": "wine"
          },
          {
            "label": "Vineyards",
            "icon": "grape"
          },
          {
            "label": "Scenic Views",
            "icon": "landscape"
          }
        ]
      }
    ]
  },
  "culture": {
    "slides": [
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/mc-pardt-art-gallery-723508487-38328?wid=1400&fit=constrain",
        "title": "Historic City Explorations",
        "description": "Walk through centuries of history in beautifully preserved ancient cities.",
        "buttonLink": "https://moments.marriottbonvoy.com/en-us/moments/category/arts-lifestyle",
        "activities": [
          {
            "label": "Historic Sites",
            "icon": "historic"
          },
          {
            "label": "City Walking",
            "icon": "walking"
          },
          {
            "label": "Architecture",
            "icon": "building"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/br-huzbr-dong-ping-art-20156?wid=1400&fit=constrain",
        "title": "Art & Museum Tours",
        "description": "Immerse yourself in world-renowned galleries and cultural institutions.",
        "buttonLink": "https://activities.marriott.com/activities?term=culture",
        "activities": [
          {
            "label": "Museums",
            "icon": "museum"
          },
          {
            "label": "Art Galleries",
            "icon": "art"
          },
          {
            "label": "Guided Tours",
            "icon": "tour"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/content/dam/marriott-renditions/dm-static-renditions/stock/getty/en_us/getty_7/photo/assets/gettyimages-157186439-gigapixel-art-height-2600px-classic-hor.jpg",
        "title": "Cultural Festival Experiences",
        "description": "Celebrate local traditions and festivals with authentic cultural immersion.",
        "buttonLink": "https://traveler.marriott.com/culture-and-style/art-and-museums/",
        "activities": [
          {
            "label": "Festivals",
            "icon": "festival"
          },
          {
            "label": "Local Traditions",
            "icon": "tradition"
          },
          {
            "label": "Cultural Events",
            "icon": "event"
          }
        ]
      }
    ]
  },
  "spa": {
    "slides": [
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/mc-auhal-saray-spa-33836?wid=1400&fit=constrain",
        "title": "Luxury Wellness Retreats",
        "description": "Rejuvenate mind, body, and spirit at world-class spa destinations.",
        "buttonLink": "https://www.marriott.com/en-us/resorts/spa-resorts.mi",
        "activities": [
          {
            "label": "Spa Treatments",
            "icon": "spa"
          },
          {
            "label": "Wellness",
            "icon": "wellness"
          },
          {
            "label": "Luxury Resort",
            "icon": "luxury"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/br-phxbd-day-spa-24072?wid=1400&fit=constrain",
        "title": "Thermal Springs Escapes",
        "description": "Soak in natural hot springs surrounded by breathtaking landscapes.",
        "buttonLink": "https://traveler.marriott.com/spa/worlds-best-hotel-spas/",
        "activities": [
          {
            "label": "Hot Springs",
            "icon": "springs"
          },
          {
            "label": "Natural Healing",
            "icon": "nature"
          },
          {
            "label": "Relaxation",
            "icon": "relax"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/content/dam/marriott-renditions/dm-static-renditions/rz/emea/hws/e/ejhrz/en_us/photo/unlimited/assets/rz-ejhrz-yoga-pavilion-31557-82785-classic-hor.jpg",
        "title": "Meditation & Mindfulness",
        "description": "Find inner peace through guided meditation and wellness practices.",
        "buttonLink": "https://traveler.marriott.com/wellness/mindful-travel/",
        "activities": [
          {
            "label": "Meditation",
            "icon": "meditation"
          },
          {
            "label": "Mindfulness",
            "icon": "mindful"
          },
          {
            "label": "Inner Peace",
            "icon": "peace"
          }
        ]
      }
    ]
  },
  "music": {
    "slides": [
      {
        "image": "https://cache.marriott.com/content/dam/marriott-renditions/dm-static-renditions/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1464095590-29450-classic-hor.jpg",
        "title": "Music Festival Getaways",
        "description": "Experience world-class music festivals and exclusive backstage access.",
        "buttonLink": "https://moments.marriottbonvoy.com/en-us/moments/category/entertainment",
        "activities": [
          {
            "label": "Music Festivals",
            "icon": "festival"
          },
          {
            "label": "Live Music",
            "icon": "music"
          },
          {
            "label": "Backstage Access",
            "icon": "vip"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com//content/dam/marriott-renditions/dm-static-renditions/wh/us-canada/hws/m/miaws/en_us/photo/unlimited/assets/wh-miaws-live-music-35312-standard-hor.jpg",
        "title": "Concert Hall Experiences",
        "description": "Attend intimate performances at legendary music venues worldwide.",
        "buttonLink": "https://traveler.marriott.com/culture-and-style/top-music-festivals/",
        "activities": [
          {
            "label": "Concert Halls",
            "icon": "concert"
          },
          {
            "label": "Live Performances",
            "icon": "performance"
          },
          {
            "label": "Legendary Venues",
            "icon": "venue"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/mc-tricc-girls-at-music-festival--16205?wid=1400&fit=constrain",
        "title": "Jazz & Blues Tours",
        "description": "Explore the birthplaces of jazz and blues in authentic settings.",
        "buttonLink": "https://w-hotels.marriott.com/w-presents/",
        "activities": [
          {
            "label": "Jazz Music",
            "icon": "jazz"
          },
          {
            "label": "Blues Heritage",
            "icon": "blues"
          },
          {
            "label": "Music History",
            "icon": "history"
          }
        ]
      }
    ]
  },
  "hike": {
    "slides": [
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/oc-mb-outdoors-hiking-25290?wid=1400&fit=constrain",
        "title": "Epic Mountain Trails",
        "description": "Trek through dramatic landscapes and reach breathtaking summit views.",
        "buttonLink": "https://www.marriott.com/en-us/outdoors/camping-and-hiking",
        "activities": [
          {
            "label": "Mountain Hiking",
            "icon": "mountain"
          },
          {
            "label": "Summit Views",
            "icon": "summit"
          },
          {
            "label": "Trekking",
            "icon": "hiking"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1056063176?wid=1400&fit=constrain",
        "title": "National Park Adventures",
        "description": "Explore diverse ecosystems and wildlife in protected wilderness areas.",
        "buttonLink": "https://traveler.marriott.com/hiking-and-biking/best-places-to-hike/",
        "activities": [
          {
            "label": "National Parks",
            "icon": "park"
          },
          {
            "label": "Wildlife Viewing",
            "icon": "wildlife"
          },
          {
            "label": "Nature Trails",
            "icon": "nature"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/oc-summer-hike-in-montana-23036?wid=1400&fit=constrain",
        "title": "Coastal Hiking Escapes",
        "description": "Walk dramatic clifftop paths with stunning ocean panoramas.",
        "buttonLink": "https://traveler.marriott.com/hiking-and-biking/best-hikes-in-world/",
        "activities": [
          {
            "label": "Coastal Trails",
            "icon": "coast"
          },
          {
            "label": "Ocean Views",
            "icon": "ocean"
          },
          {
            "label": "Cliff Walking",
            "icon": "cliff"
          }
        ]
      }
    ]
  },
  "bike": {
    "slides": [
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/oc-mb-outdoors-biking-23977?wid=1400&fit=constrain",
        "title": "Scenic Cycling Routes",
        "description": "Pedal through picturesque countryside and charming villages.",
        "buttonLink": "https://www.marriott.com/en-us/outdoors/biking",
        "activities": [
          {
            "label": "Scenic Cycling",
            "icon": "cycling"
          },
          {
            "label": "Countryside",
            "icon": "countryside"
          },
          {
            "label": "Village Tours",
            "icon": "village"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-916255624?wid=1400&fit=constrain",
        "title": "Mountain Biking Adventures",
        "description": "Conquer challenging trails with adrenaline-pumping descents.",
        "buttonLink": "https://traveler.marriott.com/hiking-and-biking/best-cycling-vacations/",
        "activities": [
          {
            "label": "Mountain Biking",
            "icon": "mtb"
          },
          {
            "label": "Adventure Trails",
            "icon": "trail"
          },
          {
            "label": "Adrenaline",
            "icon": "adrenaline"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-555000999?wid=1400&fit=constrain",
        "title": "Urban Bike Tours",
        "description": "Explore cities sustainably while discovering hidden local gems.",
        "buttonLink": "https://traveler.marriott.com/hiking-and-biking/best-places-to-mountain-bike/",
        "activities": [
          {
            "label": "Urban Cycling",
            "icon": "city"
          },
          {
            "label": "City Tours",
            "icon": "tour"
          },
          {
            "label": "Local Gems",
            "icon": "gem"
          }
        ]
      }
    ]
  },
  "surf": {
    "slides": [
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/oc-mb-outdoors-surfing-35181?wid=1400&fit=constrain",
        "title": "Perfect Wave Hunting",
        "description": "Chase legendary swells at world-famous surf breaks around the globe.",
        "buttonLink": "https://www.marriott.com/en-us/outdoors/surfing",
        "activities": [
          {
            "label": "Wave Hunting",
            "icon": "wave"
          },
          {
            "label": "Surf Breaks",
            "icon": "break"
          },
          {
            "label": "Legendary Swells",
            "icon": "swell"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-507006402?wid=1400&fit=constrain",
        "title": "Surf School Getaways",
        "description": "Learn to surf with professional instruction in tropical paradise.",
        "buttonLink": "https://traveler.marriott.com/watersports/best-places-to-surf/",
        "activities": [
          {
            "label": "Surf Lessons",
            "icon": "lesson"
          },
          {
            "label": "Professional Instruction",
            "icon": "instructor"
          },
          {
            "label": "Tropical Paradise",
            "icon": "tropical"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1314586365?wid=1400&fit=constrain",
        "title": "Big Wave Adventures",
        "description": "Experience the thrill of surfing massive waves with expert guides.",
        "buttonLink": "https://traveler.marriott.com/indonesia/carve-waves-hottest-bali-surf-spots/",
        "activities": [
          {
            "label": "Big Wave Surfing",
            "icon": "bigwave"
          },
          {
            "label": "Massive Waves",
            "icon": "massive"
          },
          {
            "label": "Expert Guides",
            "icon": "expert"
          }
        ]
      }
    ]
  },
  "fish": {
    "slides": [
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/oc-mb-outdoors-fishing-32864?wid=1400&fit=constrain",
        "title": "Deep Sea Fishing Charters",
        "description": "Battle trophy fish in deep ocean waters with experienced captains.",
        "buttonLink": "https://www.marriott.com/en-us/outdoors/fishing",
        "activities": [
          {
            "label": "Deep Sea Fishing",
            "icon": "deepsea"
          },
          {
            "label": "Trophy Fish",
            "icon": "trophy"
          },
          {
            "label": "Charter Boats",
            "icon": "charter"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1179787384?wid=1400&fit=constrain",
        "title": "Fly Fishing Expeditions",
        "description": "Master the art of fly fishing in pristine mountain streams and lakes.",
        "buttonLink": "https://traveler.marriott.com/watersports/best-places-to-fish/",
        "activities": [
          {
            "label": "Fly Fishing",
            "icon": "flyfish"
          },
          {
            "label": "Mountain Streams",
            "icon": "stream"
          },
          {
            "label": "Pristine Waters",
            "icon": "pristine"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1337989734?wid=1400&fit=constrain",
        "title": "Lake Fishing Retreats",
        "description": "Enjoy peaceful fishing in serene lakeside settings with luxury lodges.",
        "buttonLink": "https://traveler.marriott.com/united-states/best-lakeside-resorts/",
        "activities": [
          {
            "label": "Lake Fishing",
            "icon": "lake"
          },
          {
            "label": "Serene Settings",
            "icon": "serene"
          },
          {
            "label": "Luxury Lodges",
            "icon": "lodge"
          }
        ]
      }
    ]
  },
  "paddle": {
    "slides": [
      {
        "image": "https://cache.marriott.com/content/dam/marriott-renditions/dm-static-renditions/oc/global-property-shared/en_us/photo/08-2025-photoshoot/unlimited/assets/oc-mb-outdoors-kayaking-18589-classic-hor.jpg",
        "title": "Kayaking Adventures",
        "description": "Paddle through pristine waterways and discover hidden coves.",
        "buttonLink": "https://www.marriott.com/en-us/outdoors/kayaking-and-canoeing",
        "activities": [
          {
            "label": "Kayaking",
            "icon": "kayak"
          },
          {
            "label": "Pristine Waterways",
            "icon": "waterway"
          },
          {
            "label": "Hidden Coves",
            "icon": "cove"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1281848693?wid=1400&fit=constrain",
        "title": "Stand-Up Paddleboarding",
        "description": "Glide across crystal-clear waters while enjoying stunning scenery.",
        "buttonLink": "https://traveler.marriott.com/watersports/best-places-to-kayak/",
        "activities": [
          {
            "label": "Paddleboarding",
            "icon": "sup"
          },
          {
            "label": "Crystal Waters",
            "icon": "crystal"
          },
          {
            "label": "Stunning Scenery",
            "icon": "scenery"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1257426806?wid=1400&fit=constrain",
        "title": "River Rafting Thrills",
        "description": "Navigate exciting rapids on guided white-water adventures.",
        "buttonLink": "https://traveler.marriott.com/greece/watersports-costa-navarino-greece/",
        "activities": [
          {
            "label": "River Rafting",
            "icon": "raft"
          },
          {
            "label": "Rapids",
            "icon": "rapids"
          },
          {
            "label": "White-water",
            "icon": "whitewater"
          }
        ]
      }
    ]
  },
  "dive": {
    "slides": [
      {
        "image": "https://cache.marriott.com/content/dam/marriott-renditions/dm-static-renditions/oc/global-property-shared/en_us/photo/08-2025-photoshoot/unlimited/assets/oc-mb-outdoors-diving-41476-standard-hor.jpg",
        "title": "Coral Reef Diving",
        "description": "Explore vibrant underwater ecosystems teeming with marine life.",
        "buttonLink": "https://www.marriott.com/en-us/outdoors/snorkeling-and-scuba-diving",
        "activities": [
          {
            "label": "Coral Reef Diving",
            "icon": "coral"
          },
          {
            "label": "Marine Life",
            "icon": "marine"
          },
          {
            "label": "Underwater Ecosystems",
            "icon": "ecosystem"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1142861831?wid=1400&fit=constrain",
        "title": "Wreck Diving Adventures",
        "description": "Discover sunken ships and their fascinating underwater histories.",
        "buttonLink": "https://traveler.marriott.com/watersports/best-places-to-dive/",
        "activities": [
          {
            "label": "Wreck Diving",
            "icon": "wreck"
          },
          {
            "label": "Sunken Ships",
            "icon": "ship"
          },
          {
            "label": "Underwater History",
            "icon": "history"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1130867214?wid=1400&fit=constrain",
        "title": "Cave Diving Expeditions",
        "description": "Navigate mysterious underwater caverns with expert dive guides.",
        "buttonLink": "https://traveler.marriott.com/caribbean-latin-america/bvi-scuba-diving-snorkeling/",
        "activities": [
          {
            "label": "Cave Diving",
            "icon": "cave"
          },
          {
            "label": "Underwater Caverns",
            "icon": "cavern"
          },
          {
            "label": "Expert Guides",
            "icon": "expert"
          }
        ]
      }
    ]
  },
  "safari": {
    "slides": [
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-154891670?wid=1400&fit=constrain",
        "title": "African Wildlife Safaris",
        "description": "Witness the Big Five in their natural habitat on luxury safari adventures.",
        "buttonLink": "https://traveler.marriott.com/safari/alternative-african-safari-tours/",
        "activities": [
          {
            "label": "African Wildlife",
            "icon": "wildlife"
          },
          {
            "label": "Big Five",
            "icon": "bigfive"
          },
          {
            "label": "Luxury Safari",
            "icon": "luxury"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-83389523?wid=1400&fit=constrain",
        "title": "Great Migration Experience",
        "description": "Follow the world's greatest wildlife migration across vast plains.",
        "buttonLink": "https://traveler.marriott.com/safari/hotel-outdoor-experiences/",
        "activities": [
          {
            "label": "Great Migration",
            "icon": "migration"
          },
          {
            "label": "Wildlife Spectacle",
            "icon": "spectacle"
          },
          {
            "label": "Vast Plains",
            "icon": "plains"
          }
        ]
      },
      {
        "image": "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-2158798075?wid=1400&fit=constrain",
        "title": "Luxury Tented Safaris",
        "description": "Experience the wilderness in comfort with premium safari camps.",
        "buttonLink": "https://traveler.marriott.com/safari/east-africa-ultimate-destination/",
        "activities": [
          {
            "label": "Luxury Tents",
            "icon": "tent"
          },
          {
            "label": "Premium Camps",
            "icon": "camp"
          },
          {
            "label": "Wilderness Comfort",
            "icon": "comfort"
          }
        ]
      }
    ]
  },
  "am-drinks": {
    "slides": []
  },
  "afternoon-drinks": {
    "slides": []
  },
  "evening-drinks": {
    "slides": []
  }
}